import { Toaster } from "react-hot-toast";

export function SeshToaster() {
	return (
		<Toaster
			position="bottom-center"
			toastOptions={{
				style: {
					background: "#1f242b", // base.primary from tailwind config
					color: "#ffffff", // content.primary from tailwind config
					border: "1px solid #313a46", // base.light from tailwind config
					borderRadius: "6px",
				},
				success: {
					iconTheme: {
						primary: "#44d788", // success.primary from tailwind config
						secondary: "#29303a", // base.primary from tailwind config
					},
				},
				error: {
					iconTheme: {
						primary: "#ff5500", // warning from tailwind config
						secondary: "#29303a", // base.primary from tailwind config
					},
				},
			}}
		/>
	);
}
